<template>
  <a-layout class="nhf-app">
    <a-layout-content class="nhf-editor">
      <a-row justify="space-between" type="flex" class="nhf-header">
        <h1 class="nhf-title" @click="goBack">
          <img class="nhf-logo" :src="logo" alt="返回上一页面" />
          <span class="newTextColor">{{ factoryName }}</span>
        </h1>
        <a-space>
          <a-divider type="vertical" />
          <a-button size="small" type="primary" @click="onFormulaCalculate"
            :disabled="formulaDetail.auditStatus === 86">配方计算</a-button>
          <a-button size="small" @click="onSubmitForReview" v-if="btnCanShow('sendAudit')">送审</a-button>
          <a-button size="small" type="primary" @click="onReview" :disabled="formulaDetail.auditStatus !== 86"
            v-if="btnCanShow('oemAudit')">审核</a-button>
          <a-button size="small" type="primary" @click="onGenerateProduct"
            :disabled="formulaDetail.auditStatus !== 1 && formulaDetail.auditStatus !== 3"
            v-if="btnCanShow('createOEMFormulaPro')">生成产品</a-button>
        </a-space>
      </a-row>

      <!-- 主要内容区域 -->
      <div class="nhf-container" ref="editorContainer" @contextmenu.prevent.stop="handleMenu($event)">
        <a-row type="flex" align="middle" class="nhf-header-main" justify="space-between">
          <a-space>
            <h3>{{ formulaDetail.formulaName }}</h3>
            <a-icon size="small" style="font-size: 15px" @click="onEditMasterData" type="form" />
          </a-space>
          <span class="status-section">
            <span class="product-info" v-if="productPriceInfo && (productPriceInfo.version || productPriceInfo.createTime)">
              产品: V{{ productPriceInfo.version || 1 }}({{ formatDateTime(productPriceInfo.createTime) }})
            </span>
            <span class="status-label">状态:</span>
            <span class="status-value">{{ getStatusText(formulaDetail.auditStatus) }}</span>
          </span>
        </a-row>

        <!-- 左右布局 -->
        <div class="nhf-layout" ref="box" style="overflow: hidden" v-if="layout.layoutType">
          <div class="tableleft" :style="leftStyle" v-show="layout.showSider">

            <div class="table-container">
              <div class="table-header">
                <h4>配方原料</h4>
                <a-space class="icon-bar">
                  <a-tooltip>
                    <template slot="title">添加原料</template>
                    <a-button type="link" @click="onAddIngredient">
                      <img :src="addImg" alt="添加原料" />
                    </a-button>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title">移出原料</template>
                    <a-button type="link" :disabled="selectedRowKeys.length === 0" @click="onDeleteIngredient">
                      <img :src="deleteImg" alt="移出原料" />
                    </a-button>
                  </a-tooltip>
                </a-space>
              </div>

              <resize-table :scroll="{ x: 400, y: height }" bordered size="small" :columns="ingredientColumns"
                tableName="ingredientTableColumns" :data-source="ingredientList.records" :row-key="record => record.id"
                :loading="ingredientListLoading" :pagination="false" 
                :row-selection="{ selectedRowKeys, onSelect, getCheckboxProps, onSelectAll }">
                <template slot="percentage" slot-scope="text, record">
                  <span v-if="!canEditUsage">
                    {{ text | numberFixed(3) }}
                  </span>
                  <cell-editor v-else :item="record" :len="3" name="percentage" @blur="target => OnUsageUpdate(target)"
                    :text="text" :actions="updateUsage" />
                </template>
                <template slot="productRawPercentage" slot-scope="text">
                  {{ text | numberFixed(3) }}
                </template>
                <template slot="difference" slot-scope="text, record">
                  {{ ((record.percentage || 0) - (record.productRawPercentage || 0)) | numberFixed(3) }}
                </template>
                <template slot="footer">
                  <a-alert v-if="alertFlag && selectedRows.length > 0" type="info" show-icon closable
                           @close="cancelOnly">
                    <template #message>
                      <a-row type="flex" justify="space-between">
                        <a-col>
                          <span>
                            选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                            <span class="alert-info">
                              用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                            </span>
                          </span>
                        </a-col>
                        <a-col>
                          <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
                        </a-col>
                      </a-row>
                    </template>
                  </a-alert>
                </template>
              </resize-table>
            </div>
          </div>

          <div class="resize" title="左右拖动调整宽度" v-show="layout.showSider && layout.showRight" />

          <div class="tableright" :style="rightStyle" v-show="layout.showRight">
            <div class="table-container">
              <div class="table-header">
                <h4>配方营养需要量</h4>
              </div>

              <resize-table :scroll="{ x: 400, y: height }" bordered size="small" :columns="nutritionUsageColumns"
                tableName="nutritionTableColumns" :data-source="nutritionUsageList.records"
                :row-key="record => record.id" :loading="nutritionListLoading" :pagination="false">
                <template slot="content" slot-scope="text,record">
                  {{ text | numberFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) }}
                </template>
              </resize-table>
            </div>
          </div>
        </div>

        <!-- 标签页布局 -->
        <a-tabs v-else @change="tabChange" :activeKey="tabSelect" :animated="false">
          <a-tab-pane key="1" tab="配方原料" :forceRender="true">
            <div class="table-container">
              <div class="table-header">
                <h4>配方原料</h4>
                <a-space class="icon-bar">
                  <a-tooltip>
                    <template slot="title">添加原料</template>
                    <a-button type="link" @click="onAddIngredient">
                      <img :src="addImg" alt="添加原料" />
                    </a-button>
                  </a-tooltip>
                  <a-tooltip>
                    <template slot="title">移出原料</template>
                    <a-button type="link" :disabled="selectedRowKeys.length === 0" @click="onDeleteIngredient">
                      <img :src="deleteImg" alt="移出原料" />
                    </a-button>
                  </a-tooltip>
                </a-space>
              </div>

              <resize-table :scroll="{ x: 400, y: height }" bordered size="small" :columns="ingredientColumns"
                tableName="ingredientTableColumns" :data-source="ingredientList.records" :row-key="record => record.id"
                :loading="ingredientListLoading" :pagination="false" 
                :row-selection="{ selectedRowKeys, onSelect, getCheckboxProps, onSelectAll }">
                <template slot="percentage" slot-scope="text, record">
                  <span v-if="!canEditUsage">
                    {{ text | numberFixed(3) }}
                  </span>
                  <cell-editor v-else :item="record" :len="3" name="percentage" @blur="target => OnUsageUpdate(target)"
                    :text="text" :actions="updateUsage" />
                </template>
                <template slot="productRawPercentage" slot-scope="text">
                  {{ text | numberFixed(3) }}
                </template>
                <template slot="difference" slot-scope="text, record">
                  {{ ((record.percentage || 0) - (record.productRawPercentage || 0)) | numberFixed(3) }}
                </template>
                <template slot="footer">
                  <a-alert v-if="alertFlag && selectedRows.length > 0" type="info" show-icon closable
                           @close="cancelOnly">
                    <template #message>
                      <a-row type="flex" justify="space-between">
                        <a-col>
                          <span>
                            选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                            <span class="alert-info">
                              用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                            </span>
                          </span>
                        </a-col>
                        <a-col>
                          <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
                        </a-col>
                      </a-row>
                    </template>
                  </a-alert>
                </template>
              </resize-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="配方营养需要量" :forceRender="true">
            <div class="table-container">
              <div class="table-header">
                <h4>配方营养需要量</h4>
              </div>

              <resize-table :scroll="{ x: 400, y: height }" bordered size="small" :columns="nutritionUsageColumns"
                tableName="nutritionTableColumns" :data-source="nutritionUsageList.records"
                :row-key="record => record.id" :loading="nutritionListLoading" :pagination="false">
                <template slot="content" slot-scope="text">
                  {{ text | numberFixed(2) }}
                </template>
              </resize-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-layout-content>

    <!-- 右键菜单 -->
    <vue-simple-context-menu :elementId="'layoutMenu'" :options="layoutOption" ref="contextMenuContainer"
      @option-clicked="menuChecked" />

    <!-- 编辑主数据弹窗 -->
    <a-modal title="编辑" :visible="editModalVisible" @ok="onUpdateFormulaConfirmBtnClick" @cancel="onCancelBtnClick"
      :confirm-loading="editModalLoading">
      <a-form :form="form">
        <a-form-item label="配方名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input v-decorator="[
            'formulaName',
            {
              rules: [
                { required: true, message: '请输入配方名称' },
                { pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/, message: '配方名称不能包含特殊字符' }
              ],
              initialValue: formulaDetail.formulaName
            }
          ]" />
        </a-form-item>
        <a-form-item label="动物类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input v-if="formulaDetail.id && isChange" :style="inputStyle" v-model="animalName" placeholder="请选择动物类型">
            <a-icon slot="suffix" type="down" style="font-size: 12px;color: #ccc;" />
          </a-input>
          <a-cascader ref="cascader" :options="animal" :load-data="loadAnimalData" :style="cascaderStyle"
            @change="onAnimalChange" size="small" :placeholder="formValue.animal" v-model="formData.animal" />
        </a-form-item>
        <a-form-item label="备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-textarea v-decorator="[
            'remark',
            { initialValue: formulaDetail.remark }
          ]" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 新增原料弹窗 -->
    <a-modal :visible="showAdd" :confirm-loading="confirmLoading" @cancel="onAddIngredientModalClose"
      :maskClosable="false" width="1000px" destroyOnClose class="modalStyle">
      <p slot="title">
        <a-alert message="请添加原料到您的配方中" banner />
      </p>
      <OemMaterialAdd ref="add" :typeList="typeList" @getTypeList="refreshTypeList" :leftTitle="leftTitle"
        :rightTitle="rightTitle" :formulaId="$route.query.id" :factoryId="factoryId" />
      <div slot="footer" style="text-align: right">
        <a-button @click="onAddIngredientModalClose">取消</a-button>
        <a-button type="primary" @click="onAddIngredientConfirm">确定</a-button>
      </div>
    </a-modal>

    <!-- 生成产品二次确认弹窗 -->
    <a-modal v-model="showGenerateProductModal" title="生成产品" ok-text="继续" cancel-text="取消" @ok="handleGenerateProductOk"
      @cancel="handleGenerateProductCancel">
      <div style="text-align: center; font-size: 16px; font-weight: bold;">
        <span style="color: #f05757;">配方未审核，如果选择生成产品，将默认审核通过，</span>
        <span style="color: #888; font-weight: normal;">你还要继续吗？</span>
      </div>
    </a-modal>

    <!-- 审核弹窗（参照列表页批量审核样式） -->
    <a-modal title="审核" :visible="reviewVisible" @ok="confirmReview" @cancel="cancelReview" okText="确定"
      cancelText="取消">
      <a-form-model layout="vertical">
        <a-alert
          message="审核通过后, 配方将自动生成新版本的产品记录"
          type="warning"
          show-icon
          banner
          style="margin-bottom: 16px;"
        />
        <a-form-model-item style="margin-bottom: 8px;">
          <span style="margin-right: 8px;">配方:</span>
          {{ formulaDetail.formulaName || '-' }}
        </a-form-model-item>
        <a-form-model-item label="审核结果" style="margin-bottom: 0;">
          <a-radio-group v-model="singleAuditStatus">
            <a-radio :value="3"><span :style="{ color: getStatusColor(3) }">审核通过</span></a-radio>
            <a-radio :value="4"><span :style="{ color: getStatusColor(4) }">审核撤销</span></a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout>
</template>

<script>
import logo from "../../../assets/images/logo_nhf.svg";
import fullScreen from '@/assets/images/icon/fullScreen.png';
import exitFullScreen from '@/assets/images/icon/exitFullScreen.png';
import gradientAnalysis from '@/assets/images/icon/gradientAnalysis.png';
import addImg from '@/assets/images/icon/add.png';
import deleteImg from '@/assets/images/icon/delete.png';
import moment from 'moment';
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import ResizeTable from "@/components/Common/components/ResizeTable.vue";
import OemMaterialAdd from "./modal/OemMaterialAdd.vue";
import CellEditor from "@/components/Formula/editor/CellEditor.vue";
import { nhfMixins } from "../untils";
import api from "./api";
import { getRequest } from "@/components/Common/Utils/Utils.js";
import { mapState } from 'vuex';

// 添加列配置
const ingredientColumns = [
  {
    title: '原料名称',
    dataIndex: 'rawName',
    key: 'rawName',
    width: 160,
    align: 'center',
    ellipsis: true
  },
  {
    title: '代码',
    dataIndex: 'rawCode',
    key: 'rawCode',
    width: 120,
    align: 'center',
    ellipsis: true
  },
  {
    title: '用量(%)',
    dataIndex: 'percentage',
    key: 'percentage',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'percentage' }
  },
  {
    title: '产品(%)',
    dataIndex: 'productRawPercentage',
    key: 'productRawPercentage',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'productRawPercentage' }
  },
  {
    title: '差异(%)',
    dataIndex: 'difference',
    key: 'difference',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'difference' }
  }
];

const nutritionUsageColumns = [
  {
    title: '指标名称',
    dataIndex: 'nutritionName',
    key: 'nutritionName',
    align: 'center',
    width: 140,
    ellipsis: true
  },
  {
    title: '指标全称',
    dataIndex: 'nutritionFullName',
    key: 'nutritionFullName',
    width: 140,
    align: 'center',
    ellipsis: true
  },
  {
    title: '数值',
    dataIndex: 'content',
    key: 'content',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'content' }
  },
  {
    title: '单位',
    dataIndex: 'unit',
    key: 'unit',
    width: 80,
    align: 'center'
  }
];

export default {
  name: 'OEMFormulaDesign',
  components: {
    VueSimpleContextMenu,
    ResizeTable,
    OemMaterialAdd,
    CellEditor
  },
  mixins: [nhfMixins],
  data() {
    return {
      logo, fullScreen, exitFullScreen, gradientAnalysis, addImg, deleteImg, // icon
      factoryName: window.localStorage.getItem("factoryName"), //工厂名称
      leftHalfWidth: null,
      rightHalfWidth: null,
      // 添加列配置
      ingredientColumns,
      nutritionUsageColumns,
      // API相关
      ingredientListLoading: false,
      nutritionListLoading: false,
      ingredientList: {
        records: []
      },
      nutritionUsageList: {
        records: []
      },
      // 选择相关
      selectedRowKeys: [],
      selectedRows: [],
      maxLen: 100,
      // 选中原料统计
      totalPercentage: 0,
      alertFlag: true,
      tabSelect: "1",
      editModalVisible: false,
      editModalLoading: false,
      form: this.$form.createForm(this),
      selectedAnimal: {},
      formulaDetail: {},
      // 表单数据
      formData: {
        animal: [],
      },
      // 添加原料弹窗相关
      showAdd: false,
      confirmLoading: false,
      typeList: [],
      leftTitle: "",
      rightTitle: window.localStorage.getItem("factoryName"),
      // 用户角色信息
      userRole: null,
      showGenerateProductModal: false,
      // 审核弹窗
      reviewVisible: false,
      singleAuditStatus: 3,
      // 工厂ID - 从localStorage获取
      factoryId: null,
      // 动物类型相关
      isChange: true,
      animalName: '',
      inputStyle: 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);',
      cascaderStyle: 'opacity: 0',
      animal: [],
      formValue: {
        animal: '选择动物类型'
      },
      deleteIds: [], // 用于过滤已删除的动物类型
      // 产品价格信息
      productPriceInfo: null,
    };
  },
  async created() {
    this.initializeComponent();
    // 从localStorage获取factoryId
    this.factoryId = window.localStorage.getItem('factoryId');

    // 如果权限数据为空，重新获取权限数据
    if (!this.btnList || this.btnList.length === 0) {
      await this.getButtonPermissions();
    }

    const id = getRequest('id');
    if (id) {
      const res = await api.getFormulaDetail({ formulaId: id });
      if (res.success) {
        this.formulaDetail = res.data;
      }
      // 获取产品价格信息
      await this.getProductPriceInfo(id);
    }
    // 获取用户角色信息
    await this.getUserRole();
    // 初始化动物类型
    this.initAnimal();
  },
  watch: {
    "layout.layoutType"() {
      this.initSize();
      this.getContainerHeight();
      this.init();
    },
    "formulaDetail.animalTypeCode"() {
      // 当配方详情加载完成后，设置动物类型的初始值
      if (this.formulaDetail.animalTypeCode) {
        this.formData.animal = [this.formulaDetail.animalTypeCode];
        this.animalName = this.formulaDetail.animalTypeName;
        this.formValue.animal = this.formulaDetail.animalTypeName;
        // 确保编辑模式下显示输入框
        if (this.formulaDetail.id) {
          this.isChange = true;
          this.inputStyle = 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);';
          this.cascaderStyle = 'opacity: 0';
        }
      }
    },
  },
  computed: {
    ...mapState('home', ['btnList']),
    buttonList() {
      // 从store中获取OEM配方相关的按钮权限列表
      if (this.btnList && this.btnList.length > 0) {
        const oemFormula = this.btnList.find(el => el.code === 'OEM-formula');
        return oemFormula ? oemFormula.children || [] : [];
      }
      return [];
    },
    leftStyle() {
      const { leftHalfWidth } = this;
      const { showRight, showSider, layoutType } = this.layout;
      let width = '';

      if (layoutType) {
        if (showSider && showRight && leftHalfWidth) {
          width = `${leftHalfWidth}px`;
        } else if (showSider && !showRight) {
          width = '100%';
        }
      }

      return {
        width,
        float: layoutType && showSider && !showRight ? "none" : "left",
      };
    },
    rightStyle() {
      const { rightHalfWidth } = this;
      const { showRight, showSider, layoutType } = this.layout;
      let width = '';

      if (layoutType) {
        if (showSider && showRight && rightHalfWidth) {
          width = `${rightHalfWidth}px`;
        } else if (!showSider && showRight) {
          width = '100%';
        }
      }

      return {
        width,
      };
    },
    layoutOption() {
      const { showSider, showRight, layoutType } = this.layout;

      const layoutItems = [
        {
          name: '切换布局',
          commit: 'layoutType'
        }
      ];

      if (layoutType) {
        layoutItems.push(
          {
            type: 'divider'
          },
          {
            name: `<b>配方原料列表</b> ${showSider ? "<i />" : ""}`,
            commit: 'showSider'
          },
          {
            name: `<b>配方营养需要量</b> ${showRight ? "<i />" : ""}`,
            commit: 'showRight'
          }
        );
      }

      const operationItems = [
        {
          type: 'divider'
        },
        {
          name: '添加原料',
          commit: (this.formulaDetail.auditStatus === 86) ? '' : 'addIngredient',
          class: (this.formulaDetail.auditStatus === 86) ? 'disabledMenu' : ''
        },
        {
          name: '移出原料',
          commit: this.selectedRowKeys.length > 0 ? 'deleteIngredient' : '',
          class: this.selectedRowKeys.length === 0 ? 'disabledMenu' : '',
        },
        {
          type: 'divider'
        },
        {
          name: '配方计算',
          commit: (this.formulaDetail.auditStatus === 86) ? '' : 'formulaCalculate',
          class: (this.formulaDetail.auditStatus === 86) ? 'disabledMenu' : '',
          show: this.btnCanShow('formulaCalculate')
        },
        {
          name: '送审',
          commit: (this.formulaDetail.auditStatus === 1) ? '' : 'submitForReview',
          class: (this.formulaDetail.auditStatus === 1) ? 'disabledMenu' : '',
          show: this.btnCanShow('sendAudit')
        },
        {
          name: '审核',
          commit: this.formulaDetail.auditStatus === 86 ? 'review' : '',
          class: this.formulaDetail.auditStatus !== 86 ? 'disabledMenu' : '',
          show: this.btnCanShow('oemAudit')
        },
        {
          name: '生成产品',
          commit: (this.userRole === '(饲料BU)配方师' && (this.formulaDetail.auditStatus === 1 || this.formulaDetail.auditStatus === 3)) ? 'generateProduct' : '',
          class: (this.userRole !== '(饲料BU)配方师' || (this.formulaDetail.auditStatus !== 1 && this.formulaDetail.auditStatus !== 3)) ? 'disabledMenu' : '',
          show: this.btnCanShow('createOEMFormulaPro')
        }
      ];

      // 根据权限过滤操作菜单项
      const filteredOperationItems = operationItems.filter(item => {
        // 如果是分隔符，始终显示
        if (item.type === 'divider') {
          return true;
        }
        // 如果有show属性且为false，则不显示
        if ('show' in item && !item.show) {
          return false;
        }
        return true;
      });

      return [...layoutItems, ...filteredOperationItems];
    },
    // 检查用量列是否可编辑
    canEditUsage() {
      // 配方状态 != 待审核(86)，用量列可编辑
      if (this.formulaDetail.auditStatus !== 86) {
        return true;
      }

      // 配方状态 == 待审核(86)，只有当前工厂中用户角色 == 【(饲料BU)配方师】，用量列可编辑
      if (this.formulaDetail.auditStatus === 86 && this.userRole === '(饲料BU)配方师') {
        return true;
      }

      return false;
    },

  },
  methods: {
    moment,
    /**
     * 检查按钮是否有权限显示
     * @param {string} path - 按钮路径
     * @returns {boolean} 是否有权限
     */
    btnCanShow(path) {
      return this.buttonList.some(el => el.path === path);
    },
    /**
     * 返回上一页面
     */
    goBack() {
      this.$router.push('/nhf/OEM-formula?name=代工配方');
    },
    /**
     * 格式化日期时间
     * @param {string|Date} dateTime - 日期时间
     * @returns {string} 格式化后的日期时间字符串
     */
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      return moment(dateTime).format('YYYY-MM-DD');
    },
    /**
     * 获取产品价格信息
     * @param {string|number} formulaId - 配方ID
     */
    async getProductPriceInfo(formulaId) {
      try {
        const formData = new FormData();
        formData.append('formulaId', formulaId);
        const res = await api.getProductPrice(formData);
        if (res.success && res.data) {
          this.productPriceInfo = res.data;
        }
      } catch (error) {
        console.error('获取产品价格信息失败:', error);
      }
    },
    /**
     * 初始化左右布局的尺寸
     */
    initSize() {
      this.$nextTick(() => {
        const container = this.$refs["editorContainer"];
        if (container) {
          const containerWidth = container.offsetWidth;
          const padding = 40; // 左右padding各20px
          const resizeWidth = 4; // 分隔栏宽度
          const availableWidth = containerWidth - padding - resizeWidth;

          this.leftHalfWidth = availableWidth * 0.5;
          this.rightHalfWidth = availableWidth * 0.5;
        }
      });
    },
    /**
     * 获取容器高度
     */
    getContainerHeight() {
      const boxHeight = this.$refs["editorContainer"]
        ? this.$refs["editorContainer"].offsetHeight
        : 900;
      const height = boxHeight - (this.layout.layoutType ? 140 : 160);
      this.setState && this.setState({ height });
    },
    /**
     * 初始化组件
     */
    init() {
      window.onresize = () => {
        this.$nextTick(() => {
          this.getContainerHeight();
          this.initSize();
        });
      };
      this.dragControllerDiv();
    },
    /**
     * 拖拽控制分隔栏
     */
    dragControllerDiv() {
      const resize = document.getElementsByClassName("resize");
      const left = document.getElementsByClassName("tableleft");
      const mid = document.getElementsByClassName("tableright");
      const box = document.getElementsByClassName("nhf-layout");
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = (e) => {
          resize[i].style.background = "#e8e8e8";
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = (e) => {
            var endX = e.clientX;
            var moveLenght = resize[i].left + (endX - startX);
            var maxT = box[i].clientWidth - resize[i].offsetWidth;
            if (moveLenght < 400) moveLenght = 400;
            if (moveLenght > maxT - 400) moveLenght = maxT - 400;
            resize[i].style.left = moveLenght;
            for (let j = 0; j < left.length; j++) {
              let leftWidth = parseInt((moveLenght / box[i].clientWidth) * 100);
              let rightWidth = parseInt(
                ((box[i].clientWidth - moveLenght - 5) / box[i].clientWidth) *
                100
              );
              left[j].style.width = leftWidth + "%";
              mid[j].style.width = rightWidth + "%";
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = "#fff";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },
    /**
     * 添加原料按钮点击事件
     */
    onAddIngredient() {
      // 添加原料
      this.showAdd = true;
    },
    /**
     * 删除原料按钮点击事件
     */
    onDeleteIngredient() {
      // 删除选中的原料
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要删除的原料');
        return;
      }

      this.$confirm({
        title: "提示",
        content: "确认将选中的原料从配方中删除吗？",
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          const formulaId = this.$route.query.id;
          if (!formulaId) {
            this.$message.error("配方ID不能为空");
            return;
          }

          // 构建删除参数
          const ids = this.selectedRowKeys.join(',');
          const rawIds = this.selectedRows.map(item => item.rawId).join(',');

          const data = {
            ids: ids,
            rawIds: rawIds,
            formulaId: formulaId
          };

          this.$http
            .post("/nhf-app/formulaManage/remove", data)
            .then(async (res) => {
              let { success } = res;
              if (success) {
                this.$message.success("删除成功");
                this.getIngredientList(); // 刷新原料列表
                this.cleanSelect(); // 清理选择状态

                // 删除原料成功后，调用状态更新接口
                try {
                  const statusUpdateRes = await api.updateFormulaToModified(this.formulaDetail.id);
                  if (statusUpdateRes.success) {
                    console.log('状态更新成功');
                    // 状态更新成功后，同步更新本地状态值
                    this.formulaDetail.auditStatus = 5;
                  } else {
                    console.warn('状态更新失败:', statusUpdateRes.message);
                  }
                } catch (statusError) {
                  console.error('状态更新接口调用失败:', statusError);
                }
              } else {
                this.$message.error("删除失败");
              }
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        },
        onCancel() {
          console.log("取消删除。");
        },
      });
    },

    /**
     * 获取复选框属性
     * @param {Object} record 行数据
     * @returns {Object} 复选框属性
     */
    getCheckboxProps(record) {
      return ({
        props: {
          disabled: (!this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length >= this.maxLen),
        }
      });
    },

    /**
     * 清理选择状态
     */
    cleanSelect() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    // 选中原料统计：仅用量合计
    computerTotal(data) {
      this.totalPercentage = 0;
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.selectedRows.forEach((item) => {
          // 如果本次更新项与已选中项是同一条数据，同步覆盖其百分比与价格
          if (data && ((item.rawId && data.rawId && item.rawId === data.rawId) || (item.id && data.id && item.id === data.id))) {
            if (data.percentage !== undefined) item.percentage = data.percentage;
          }
          if (item.percentage || item.percentage === 0) {
            this.totalPercentage = this.totalPercentage + (Number(item.percentage) || 0);
          }
        });
        if (this.totalPercentage !== 0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000);
        }
      }
    },

    // 仅关闭提示
    cancelOnly() {
      this.totalPercentage = 0;
      this.alertFlag = false;
    },
    // 取消选中，清空统计
    cancelSelection() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.totalPercentage = 0;
      this.alertFlag = false;
    },

    /**
     * 行选择事件处理
     * @param {Object} record 行数据
     * @param {Boolean} selected 是否选中
     * @param {Array} selectedRows 已选中的行
     */

    onSelect(record, selected) {
      if (selected) {
        this.selectedRowKeys.push(record.id);
        this.selectedRows.push(record);
      } else {
        const index = this.selectedRowKeys.indexOf(record.id);
        if (index > -1) {
          this.selectedRowKeys.splice(index, 1);
          this.selectedRows.splice(index, 1);
        }
      }
      // 选择变化时刷新统计
      this.alertFlag = true;
      this.computerTotal();
    },

    /**
     * 全选事件处理
     * @param {Boolean} selected 是否全选
     * @param {Array} selectedRows 已选中的行
     * @param {Array} changeRows 变化的行
     */
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        changeRows.forEach(record => {
          if (!this.selectedRowKeys.includes(record.id)) {
            this.selectedRowKeys.push(record.id);
            this.selectedRows.push(record);
          }
        });
      } else {
        changeRows.forEach(record => {
          const index = this.selectedRowKeys.indexOf(record.id);
          if (index > -1) {
            this.selectedRowKeys.splice(index, 1);
            this.selectedRows.splice(index, 1);
          }
        });
      }
      // 全选变化时刷新统计
      this.alertFlag = true;
      this.computerTotal();
    },

    /**
     * 行样式：已删除原料置灰
     */
    rowClassname(record) {
      return record && (record.isRawDelete == 1 || record.isRawDelete === '1') ? 'selectGary' : '';
    },

    /**
     * 配方计算按钮点击事件
     */
    async onFormulaCalculate() {
      // 配方计算
      try {
        // 1. 校验配方状态和用户角色
        if (this.formulaDetail.auditStatus === 86) { // 86表示待审核状态
          this.$message.warning('配方待审核中，无法进行配方计算');
          return;
        }

        // 2. 校验配方原料是否为空
        if (!this.ingredientList.records || this.ingredientList.records.length === 0) {
          this.$message.warning('请添加原料后再计算');
          return;
        }

        // 3. 校验配方原料用量(%)总和是否等于100
        const totalUsage = this.ingredientList.records.reduce((sum, item) => {
          return sum + (parseFloat(item.percentage) || 0);
        }, 0);

        if (Math.abs(totalUsage - 100) > 0.01) { // 允许0.01的误差
          this.$message.warning('配方原料的用量(%)总和须等于100，请调整后再计算');
          return;
        }

        // 4. 调用配方计算接口
        const params = {
          id: this.formulaDetail.id
        };

        const res = await this.$http.post('/nhf-app/oemFormulaManage/oemFormulaCal', params);

        if (res.success) {
          this.$message.success('配方计算成功');
          // 刷新页面数据
          const formulaId = this.$route.query.id;
          if (formulaId) {
            const detailRes = await api.getFormulaDetail({ formulaId });
            if (detailRes.success) {
              this.formulaDetail = detailRes.data;
            }
          }
          this.getIngredientList();
          this.getNutritionList();
        } else {
          // 配方计算失败
        }
      } catch (error) {
        console.error('配方计算出错:', error);
        this.$message.error('配方计算失败');
      }
    },
    /**
     * 送审按钮点击事件
     */
    async onSubmitForReview() {
      // 送审
      try {
        console.log(this.formulaDetail.auditStatus);
        console.log(this.userRole);
        // 校验配方状态和用户角色
        if (this.formulaDetail.auditStatus === 86) { // 86表示待审核状态
          this.$message.warning('配方已处于待审核状态，无需重复送审');
          return;
        }

        // 校验配方原料是否为空
        if (!this.ingredientList.records || this.ingredientList.records.length === 0) {
          this.$message.warning('请添加原料后再送审');
          return;
        }

        // 校验配方原料用量(%)总和是否等于100
        const totalUsage = this.ingredientList.records.reduce((sum, item) => {
          return sum + (parseFloat(item.percentage) || 0);
        }, 0);

        if (Math.abs(totalUsage - 100) > 0.01) { // 允许0.01的误差
          this.$message.warning('配方原料的用量(%)总和须等于100，请调整后再送审');
          return;
        }

        this.$confirm({
          title: "确认送审",
          content: "确认将此配方送审吗？",
          cancelText: "取消",
          okText: "确定",
          onOk: async () => {
            const params = {
              id: this.formulaDetail.id,
              auditStatus: 4
            };

            const res = await api.sendAudit(params);

            if (res.success) {
              this.$message.success('送审成功');
              // 刷新配方详情
              const formulaId = this.$route.query.id;
              if (formulaId) {
                const detailRes = await api.getFormulaDetail({ formulaId });
                if (detailRes.success) {
                  this.formulaDetail = detailRes.data;
                }
              }
            } else {
              this.$message.success(res.msg);
            }
          }
        });
      } catch (error) {
        console.error('送审出错:', error);
        this.$message.error('送审失败');
      }
    },
    /**
     * 审核按钮点击事件
     */
    async onReview() {
      // 审核
      try {
        // 校验配方状态
        if (this.formulaDetail.auditStatus !== 86) {
          this.$message.warning('只有待审核状态的配方才能进行审核');
          return;
        }
        // 打开审核弹窗
        this.singleAuditStatus = 3;
        this.reviewVisible = true;
      } catch (error) {
        console.error('审核出错:', error);
        this.$message.error('审核失败');
      }
    },
    /**
     * 生成产品按钮点击事件
     */
    onGenerateProduct() {
      // 配方状态检查
      if (this.formulaDetail.auditStatus !== 1 && this.formulaDetail.auditStatus !== 3) {
        this.$message.warning('请先进行配方计算，再生成产品');
        return;
      }

      // 配方状态 == 审核通过，直接调用后端接口
      if (this.formulaDetail.auditStatus === 3) {
        this.callGenerateProductApi();
        return;
      }

      // 审核状态 == 已测算，弹窗二次确认
      if (this.formulaDetail.auditStatus === 1) {
        this.showGenerateProductModal = true;
      }
    },

    /**
     * 调用生成产品接口
     */
    async callGenerateProductApi() {
      try {
        const res = await api.oemFormulaCreateProduct({
          id: this.formulaDetail.id
        });

        if (res.success) {
          this.$message.success('产品生成成功');
          return true;
        } else {
          this.$message.error(res.msg || '产品生成失败');
          return false;
        }
      } catch (error) {
        console.error('生成产品失败:', error);
        this.$message.error('产品生成失败');
        return false;
      }
    },
    /**
     * 获取用户角色信息
     */
    async getUserRole() {
      try {
        const factoryId = window.localStorage.getItem('factoryId');
        const userInfoRes = await this.$http.get('/iot-factory/factorystaff/getStaffInfoByFactoryIdAndUserId', {
          params: { factoryId }
        });

        if (userInfoRes.success && userInfoRes.data) {
          this.userRole = userInfoRes.data.roleName;
        }
      } catch (error) {
        console.error('获取用户角色信息失败:', error);
      }
    },

    /**
     * 获取按钮权限数据
     */
    async getButtonPermissions() {
      try {
        const factoryId = window.localStorage.getItem('factoryId');
        if (factoryId) {
          const res = await this.$http.get('/iot-system/menu/buttons', { 
            params: { controlEnd: false, factoryId } 
          });
          if (res.success) {
            // 更新store中的权限数据
            this.$store.commit('home/setState', { btnList: res.data || [] });
          } else {
            console.log('获取按钮权限失败');
          }
        }
      } catch (error) {
        console.error('获取按钮权限失败:', error);
      }
    },
    /**
     * 用量更新处理
     * @param {Object} item 更新的数据项
     */
    OnUsageUpdate(item) {
      // 更新原料用量
      const newData = [...this.ingredientList.records];
      const target = newData.find(i => i.id === item.id);
      if (target) {
        Object.assign(target, item);
        this.ingredientList.records = newData;
      }
      // 更新统计
      this.alertFlag = true;
      this.computerTotal(item);
    },
    /**
     * 用量更新API调用
     * @param {Object} data 更新数据
     * @returns {Object} API响应结果
     */
    async updateUsage(data) {
      try {
        const res = await this.$http.post('/nhf-app/formularaw/update', data);
        if (res.success) {
          // 用量更新成功后，调用状态更新接口
          try {
            const statusUpdateRes = await api.updateFormulaToModified(this.formulaDetail.id);
            if (statusUpdateRes.success) {
              console.log('状态更新成功');
              // 状态更新成功后，同步更新本地状态值
              this.formulaDetail.auditStatus = 5;
            } else {
              console.warn('状态更新失败:', statusUpdateRes.message);
            }
          } catch (statusError) {
            console.error('状态更新接口调用失败:', statusError);
          }

          // 刷新配方数据
          // this.getIngredientList();
          // this.getNutritionList();
        }
        return res;
      } catch (error) {
        console.error('更新用量失败:', error);
        return { success: false };
      }
    },
    /**
     * 编辑主数据按钮点击事件
     */
    onEditMasterData() {
      this.editModalVisible = true;
    },

    /**
     * 更新配方确认按钮点击事件
     */
    onUpdateFormulaConfirmBtnClick() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // 验证动物类型是否已选择
          if (!this.formulaDetail.animalTypeCode) {
            this.$message.error('请选择动物类型');
            return;
          }

          this.editModalLoading = true;
          const params = {
            ...values,
            id: this.formulaDetail.id,
            animalTypeName: this.formulaDetail.animalTypeName,
            animalTypeCode: this.formulaDetail.animalTypeCode
          };
                     try {
             const res = await api.updateOemFormula(params);
             if (res.success) {
               // 使用values里面的值更新formulaDetail
               this.formulaDetail = {
                 ...this.formulaDetail,
                 ...values
               };
               // 更新成功后，重置动物类型组件状态
               this.isChange = true;
               this.animalName = this.formulaDetail.animalTypeName;
               this.formValue.animal = this.formulaDetail.animalTypeName;
               this.formData.animal = [this.formulaDetail.animalTypeCode];
               this.$message.success('更新成功');
               this.editModalVisible = false;
             }
           } finally {
             this.editModalLoading = false;
           }
        }
      });
    },

    /**
     * 取消按钮点击事件
     */
    onCancelBtnClick() {
      // 取消时重置动物类型组件状态
      this.isChange = true;
      this.animalName = this.formulaDetail.animalTypeName;
      this.formValue.animal = this.formulaDetail.animalTypeName;
      this.formData.animal = [this.formulaDetail.animalTypeCode];
      this.editModalVisible = false;
    },

    /**
     * 动物类型选择变化事件
     * @param {Array} val 选中的值
     * @param {Array} select 选中的选项
     */
    onAnimalChange(val, select) {
      this.animalChange(select, val);
    },

    /**
     * 初始化组件
     */
    initializeComponent() {
      this.$nextTick(() => {
        this.initSize();
        this.getContainerHeight();
        this.init();
        this.initLayoutSettings();
        this.getIngredientList();
        this.getNutritionList();
        this.getTypeList();
      });
    },

    /**
     * 处理右键菜单事件
     * @param {Event} event 事件对象
     */
    handleMenu(event) {
      this.$refs.contextMenuContainer.showMenu(event);
    },
    /**
     * 菜单选中事件处理
     * @param {Object} option 选中的选项
     */
    menuChecked({ option }) {
      const { commit } = option;
      if (commit) {
        this.rightClick({ key: commit });
      }
    },
    /**
     * 右键菜单点击事件处理
     * @param {Object} e 事件对象
     */
    rightClick(e) {
      const { key } = e || {};
      if (['layoutType', 'showSider', 'showRight'].includes(key)) {
        this.handleLayout({ key, val: !this.layout[key] });
      } else {
        switch (key) {
          case 'formulaCalculate':
            this.onFormulaCalculate();
            break;
          case 'submitForReview':
            this.onSubmitForReview();
            break;
          case 'review':
            this.onReview();
            break;
          case 'generateProduct':
            this.onGenerateProduct();
            break;
          case 'addIngredient':
            this.onAddIngredient();
            break;
          case 'deleteIngredient':
            this.onDeleteIngredient();
            break;
          default:
            console.log('未知的菜单选项:', key);
        }
      }
    },
    /**
     * 处理布局变化
     * @param {Object} e 布局事件对象
     */
    handleLayout(e) {
      const { key, val } = e || {};
      const feildObj = {
        showRight: 'showSider',
        showSider: 'showRight'
      };

      if (key === 'layoutType') {
        // 切换到左右布局时，默认同时显示左右两个面板
        if (val) {
          this.toggleLayout({ feild: key, val });
          this.toggleLayout({ feild: 'showSider', val: true });
          this.toggleLayout({ feild: 'showRight', val: true });
          // 保存到 localStorage
          window.localStorage.setItem('layoutType', 'layoutType');
          window.localStorage.setItem('showSider', 'true');
          window.localStorage.setItem('showRight', 'true');
        } else {
          this.toggleLayout({ feild: key, val });
          // 保存到 localStorage
          window.localStorage.setItem('layoutType', 'tabs');
        }
      } else {
        if (val) {
          this.toggleLayout({ feild: key, val });
          // 保存到 localStorage
          window.localStorage.setItem(key, 'true');
        } else {
          this.toggleLayout({ feild: key, val: false });
          this.toggleLayout({ feild: feildObj[key], val: true });
          // 保存到 localStorage
          window.localStorage.setItem(key, 'setFalse');
          window.localStorage.setItem(feildObj[key], 'true');
        }
      }

      setTimeout(() => {
        if (e.val && e.key === 'layoutType') {
          this.init();
        }
      }, 0);
    },
    /**
     * 标签页切换事件
     * @param {String} key 标签页key
     */
    tabChange(key) {
      this.tabSelect = key;
    },

    /**
     * 初始化布局设置
     */
    initLayoutSettings() {
      // 从 localStorage 获取布局设置
      const layoutType = window.localStorage.getItem('layoutType');
      const showSider = window.localStorage.getItem('showSider');
      const showRight = window.localStorage.getItem('showRight');

      // 设置 layoutType - 默认为左右布局
      if (layoutType === 'layoutType') {
        this.toggleLayout({
          feild: 'layoutType',
          val: true
        });
      } else if (layoutType === 'tabs') {
        this.toggleLayout({
          feild: 'layoutType',
          val: false
        });
      } else {
        // 默认设置为左右布局
        this.toggleLayout({
          feild: 'layoutType',
          val: true
        });
        // 保存到 localStorage
        window.localStorage.setItem('layoutType', 'layoutType');
      }

      // 设置 showSider
      if (showSider) {
        this.toggleLayout({
          feild: 'showSider',
          val: showSider !== 'setFalse'
        });
      } else {
        this.toggleLayout({
          feild: 'showSider',
          val: true
        });
        // 保存到 localStorage
        window.localStorage.setItem('showSider', 'true');
      }

      // 设置 showRight
      if (showRight) {
        this.toggleLayout({
          feild: 'showRight',
          val: showRight !== 'setFalse'
        });
      } else {
        this.toggleLayout({
          feild: 'showRight',
          val: true
        });
        // 保存到 localStorage
        window.localStorage.setItem('showRight', 'true');
      }
    },

    /**
     * 获取配方原料列表
     */
    async getIngredientList() {
      const formulaId = this.$route.query.id;
      if (!formulaId) return;

      const factoryId = window.localStorage.getItem('factoryId');

      await this.fetchGet({
        actions: api.getFormulaRawNhfPage,
        loading: 'ingredientListLoading',
        name: 'ingredientList',
        data: {
          formulaId: formulaId,
          factoryId: factoryId,
          current: 1,
          size: 1000
        }
      });

      // 过滤掉已删除的数据（isDeleted == 1）
      if (this.ingredientList && Array.isArray(this.ingredientList.records)) {
        this.ingredientList.records = this.ingredientList.records.filter(item => Number(item.isDeleted) !== 1);
      }

      // 清理选择状态
      this.cleanSelect();
    },

    /**
     * 获取配方营养需要量列表
     */
    async getNutritionList() {
      const formulaId = this.$route.query.id;
      if (!formulaId) return;

      await this.fetchGet({
        actions: api.getFormulaNutritionNhfPage,
        loading: 'nutritionListLoading',
        name: 'nutritionUsageList',
        data: {
          formulaId: formulaId,
          current: 1,
          size: 1000
        }
      });
    },

    /**
     * 刷新原料类型列表
     * @param {Object} data 类型数据
     */
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption);
    },

    /**
     * 获取原料类型列表
     * @param {Number} parentId 父级ID
     * @param {Object} record 记录对象
     */
    getTypeList(parentId = 0, record) {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail');
      let factoryDetail = obj ? JSON.parse(obj) : {};
      let { deptId } = factoryDetail;
      this.$http
        .get(
          `/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=raw&parentId=${parentId}&deptId=${deptId}`
        )
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          } else {
            this.typeList = [];
          }
        });
    },

    /**
     * 添加原料弹窗关闭事件
     */
    onAddIngredientModalClose() {
      if (this.$refs.add && this.$refs.add.isChange) {
        this.getIngredientList();
      }
      this.showAdd = false;
    },

    /**
     * 添加原料确认按钮点击事件
     */
    onAddIngredientConfirm() {
      // 新增提交
      let rows = this.$refs["add"].selectedRows;
      if (!rows || rows.length === 0) {
        this.$message.warning("请选择需要添加的原料");
        return;
      }

      const formulaId = this.$route.query.id;
      if (!formulaId) {
        this.$message.error("配方ID不能为空");
        return;
      }

      // 构建添加原料的数据
      let data = {
        formulaId: formulaId,
        rawIds: rows.map(item => item.rawId).join(','),
        factoryId: window.localStorage.getItem('factoryId')
      };

      this.confirmLoading = true;
      // 调用添加原料到配方的API
      this.$http
        .post("/nhf-app/formulaManage/saveFormulaRawIds", data)
        .then(async (res) => {
          let { success } = res;
          if (success) {
            this.$message.success("添加成功");
            this.getIngredientList(); // 刷新原料列表

            // 添加原料成功后，调用状态更新接口
            try {
              const statusUpdateRes = await api.updateFormulaToModified(this.formulaDetail.id);
              if (statusUpdateRes.success) {
                console.log('状态更新成功');
                // 状态更新成功后，同步更新本地状态值
                this.formulaDetail.auditStatus = 5;
              } else {
                console.warn('状态更新失败:', statusUpdateRes.message);
              }
            } catch (statusError) {
              console.error('状态更新接口调用失败:', statusError);
            }
          } else {
            // 添加失败
          }
          this.confirmLoading = false;
          this.onAddIngredientModalClose();
        })
        .catch(() => {
          this.$message.error("添加失败");
          this.confirmLoading = false;
        });
    },
    handleGenerateProductOk() {
      this.callGenerateProductApi();
      this.showGenerateProductModal = false;
    },
    handleGenerateProductCancel() {
      this.showGenerateProductModal = false;
    },
    // 审核弹窗-确定
    async confirmReview() {
      try {
        const params = {
          id: this.formulaDetail.id,
          auditStatus: this.singleAuditStatus
        };
        const res = await api.audit(params);
        if (res.success) {
          this.$message.success('审核成功');
          const formulaId = this.$route.query.id;
          if (formulaId) {
            const detailRes = await api.getFormulaDetail({ formulaId });
            if (detailRes.success) {
              this.formulaDetail = detailRes.data;
            }
          }
          // 审核通过后调用生成产品接口
          if (this.singleAuditStatus === 3) {
            const generateSuccess = await this.callGenerateProductApi();
            // 产品生成成功后刷新页面
            if (generateSuccess) {
              const formulaId = this.$route.query.id;
              if (formulaId) {
                const detailRes = await api.getFormulaDetail({ formulaId });
                if (detailRes.success) {
                  this.formulaDetail = detailRes.data;
                }
                // 刷新相关数据
                await this.getIngredientList();
                await this.getNutritionList();
                await this.getProductPriceInfo(formulaId);
              }
            }
          }
          this.reviewVisible = false;
        } else {
          this.$message.error(res.msg || '审核失败');
        }
      } catch (error) {
        console.error('审核失败:', error);
        this.$message.error('审核失败');
      }
    },
    // 审核弹窗-取消
    cancelReview() {
      this.reviewVisible = false;
    },

    /**
     * 动物类型变化处理
     * @param {Array} val 选中的值
     */
    animalChange(val) {
      this.isChange = false;
      if (val && val.length > 0) {
        if (val.length > 1) {
          const { name, id } = [...val].pop();
          const { id: animalRootId } = [...val].shift();
          this.formulaDetail.animalTypeName = name;
          this.formulaDetail.animalTypeCode = id;
          this.formulaDetail.animalRootId = animalRootId;
          this.animalName = name;
          this.formValue.animal = name;
          // 在编辑模式下，显示输入框显示选中的值，隐藏级联选择器
          if (this.formulaDetail.id) {
            this.inputStyle = 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);';
            this.cascaderStyle = 'opacity: 0';
          } else {
            // 新建模式下，隐藏输入框，显示级联选择器
            this.inputStyle = 'display: none';
            this.cascaderStyle = '';
          }
        }
      } else {
        // 清空选择时，显示级联选择器，隐藏输入框
        this.inputStyle = 'display: none';
        this.cascaderStyle = '';
        this.animalName = undefined;
        this.formulaDetail.animalTypeName = undefined;
        this.formulaDetail.animalTypeCode = undefined;
        this.formulaDetail.animalRootId = undefined;
        this.formValue.animal = '选择动物类型';
      }
    },

    /**
     * 数据映射过滤器
     * @param {Object} i 数据项
     * @returns {Object} 映射后的数据
     */
    mapFilter(i) {
      return {
        ...i,
        label: i.name,
        value: i.id,
        isLeaf: !i.hasChildren
      };
    },

    /**
     * 加载动物类型数据
     * @param {Array} selectedOptions 已选择的选项
     */
    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      const { value: parentId } = targetOption;
      let factoryId = window.localStorage.getItem('factoryId');
      const res = await this.animalTypeList({ parentId, factoryId });
      targetOption.loading = false;
      res.data = res.data.filter(el => !this.deleteIds.includes(el.id));
      targetOption.children = res.data.map(this.mapFilter);
      this.animal = [...this.animal];
    },

    /**
     * 初始化动物类型
     */
    async initAnimal() {
      let factoryId = window.localStorage.getItem('factoryId');
      const res = await this.animalTypeList({ parentId: 0, factoryId });
      const { data } = res;
      if (data && data.length && data[0].id) {
        const resAnimal = await this.animalTypeList({ parentId: data[0].id, factoryId });
        this.animal = resAnimal.data.map(this.mapFilter);
      } else {
        this.animal = res.data.map(this.mapFilter);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}

.nhf-editor {
  overflow: hidden;

  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}

.nhf-header {
  padding: 10px 20px 0;
}

.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.nhf-logo {
  height: 23px;
  margin-right: 8px;
}

.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}

.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}

.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}

.nhf-container {
  border-radius: 5px;
  background: #fff;
  min-width: 800px;
  margin: 10px 20px 15px;
  height: calc(100vh - 70px);
  border-radius: 5px;
  background: #fff;
}



.status-section {
  display: flex;
  align-items: center;
  gap: 16px;

  .product-info {
    font-size: 14px;
    margin-right: 8px;
  }

  .status-label {
    color: #666;
    margin-right: 8px;
  }

  .status-value {
    color: #fa8c16;
    font-weight: 500;
  }
}

.tableleft,
.tableright,
.resize {
  float: left;
}

.resize {
  cursor: col-resize;
  width: 4px;
  height: calc(100vh - 145px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    color: #444444;
  }

  &:after {
    left: -2px;
    right: -2px;
    border: 1px solid #888;
    border-top: none;
    border-bottom: none;
    height: 22px;
    content: "";
    margin-top: -11px;
    position: absolute;
    top: 50%;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #e8e8e8;
    width: 1px;
  }
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
  }
}

.table-container {
  border-radius: 4px;
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-shrink: 0;

  h4 {
    margin: 0;
    font-size: 14px;
    color: #333;
  }
}

.icon-bar ::v-deep .anticon {
  font-size: 16px !important;
}

.menu {
  padding: 5px 15px;

  ::v-deep .ant-radio-wrapper {
    display: block;
    margin: 10px 0;
  }
}

.disabledMenu {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.disabledMenu:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

// 让表格组件填充剩余空间
.table-container ::v-deep .ant-table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-container ::v-deep .ant-table {
  flex: 1;
}

// 置灰样式（与项目内其他处保持一致）
::v-deep .selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}

// 动物类型组件样式
::v-deep .ant-form-item {
  margin-bottom: 0;
}

::v-deep .ant-space-item {
  font-size: 12px;
}
</style>

<style lang="scss">
.vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;

  &--active {
    background: #fff;
    color: #444;
  }

  &__item {
    width: 180px;
    font-size: 13px;

    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;

      b {
        font-weight: normal;
      }
    }

    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }

    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}

.modalStyle {
  .ant-modal-header {
    padding: 0;
    border-bottom: none;
  }

  .ant-modal-close-x {
    width: 36px;
    height: 36px;
    line-height: 36px;
  }
}
</style>
